import { Component } from 'react';
import PropTypes from 'prop-types';
import { consts } from './container';

export default class AbstractOrderBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    // Order status (see statuses in container.jsx)
    status: PropTypes.string,
    // Already selected products
    selectedProducts: PropTypes.arrayOf(PropTypes.string),//eslint-disable-line
    // Function, that handles an order, injected by container
    // Call this, when you need to process order and go to pay process
    handleOrder: PropTypes.func,//eslint-disable-line
    // Product add/remove. Call this function with args: productName, active
    // product name - from products dictionary, active - true/false
    handleSelectProduct: PropTypes.func,//eslint-disable-line
    // Change advanced user's data for order
    handleChangeAdvData: PropTypes.func,//eslint-disable-line
    // Returned from backend order status information
    orderData: PropTypes.shape({}),//eslint-disable-line
    // Advanced data for order, that fills by user
    advData: PropTypes.shape({}),//eslint-disable-line
    // Full order amount
    amount: PropTypes.number//eslint-disable-line
  };

  /**
   * Render a make order block
   *
   * @abstract
   * @return Component
   */
  renderOrder(status) {
    console.error('Declare a renderOrder method', status); //eslint-disable-line
    return null;
  }

  /**
   * Render a block, that renders information about payment process is start
   *
   * @abstract
   * @return Component
   */
  renderPay() {
    console.error('Declare a renderPay method'); //eslint-disable-line
    return null;
  }

  /**
   * Render a block with information about payment status waiting
   *
   * @abstract
   * @return Component
   */
  renderPayWait() {
    console.error('Declare a renderPayWait method'); //eslint-disable-line
    return null;
  }

  /**
   * Render a block with payment result information
   *
   * @abstract
   * @return Component
   */
  renderPayed() {
    console.error('Declare a renderPayWait method'); //eslint-disable-line
    return null;
  }

  /**
   * Render a block with rejected payment information
   *
   * @abstract
   * @return Component
   */
  renderRejected() {
    console.error('Declare a renderRejected method'); //eslint-disable-line
    return null;
  }

  render() {
    const { status } = this.props;
    if (status === consts.STATUS_CHOOSE) return this.renderOrder();
    if (status === consts.STATUS_REQUEST) return this.renderOrder();
    if (status === consts.STATUS_PAY) return this.renderPay();
    if (status === consts.STATUS_WAIT) return this.renderPayWait();
    if (status === consts.STATUS_PAYED) return this.renderPayed();
    if (status === consts.STATUS_REJECTED) return this.renderRejected();

    return `UNKNOWN STATUS ${status}`;
  }
}
